import { captureException } from "@sentry/react";

const ALLOWED_ORIGINS: (string | RegExp)[] = [
  "https://grantedhealth.com",
  /^https:\/\/[^.]+\.framer\.app$/,
];

function getAllowedTargetOrigin(referrer: string): string | null {
  try {
    const referrerOrigin = new URL(referrer).origin;
    for (const allowed of ALLOWED_ORIGINS) {
      if (typeof allowed === "string") {
        if (referrerOrigin === allowed) {
          return allowed;
        }
      } else {
        if (allowed.test(referrerOrigin)) {
          return referrerOrigin;
        }
      }
    }
  } catch (error) {
    // Log error to Sentry but return null to prevent the message from being sent.
    captureException(error);
    return null;
  }
  return null;
}

type Message = {
  type: string;
  data: Record<string, unknown>;
};

export function postMessageToParent(message: Message): void {
  const targetOrigin = getAllowedTargetOrigin(document.referrer);
  if (targetOrigin) {
    window.parent.postMessage(message, targetOrigin);
  }
}
